<template>
    <ul style="height: calc(100vh - 160px); overflow-x:hidden; overflow-y: auto;background-color: #f7F7F8" ref="live_view">
        <li class="" v-for="le in live_events" :key="le.id">
            <div class="text-message" :class="hasError(le.subject)?'red':''">{{le.created_at}}:{{le.category}}:{{le.subject}}:{{le.visitor_name}}
                <el-button type="text" :icon="le.show?'el-icon-caret-bottom':'el-icon-caret-right'"
                           @click="le.show=le.show?0:1"></el-button>
            </div>
            <div v-if="le.show">
                <pre style="line-height: 18px;color: #666;overflow-x:hidden;">{{le.text}}</pre>
            </div>
        </li>
    </ul>
</template>

<script>

    import {mapState} from "vuex";
    import PushMixin from "../common/mixins/pusher-mixin"

    export default {
        name: "monitor",
        mixins:[PushMixin],
        data() {
            return {
                live: false,
            }
        },
        computed: {
            ...mapState(['user', 'process','preset']),
        },
        created() {
            this.initPusher();
        },
        destroyed() {
            if (this.pusher) this.pusher.disconnect();
        },
        methods: {
            hasError(str){
                return str.includes('ERROR');
            },
            handlePusherMessage(data){
                data.message.show = 0;
                this.live_events.push(data.message);
                if (this.live_events.length > 200) this.live_events.shift();
                this.$nextTick(() => {
                    const div = this.$refs['live_view'];
                    if (div) div.scrollTop = div.scrollHeight;
                })
            }
        }
    }
</script>

<style scoped lang="scss">

    .profile {

        .image {
            width: 36px;
            height: 36px;
        }
    }


</style>
